(function ($) {
  // Document Ready
  $(document).ready(function () {
    if ($(".case-studies-section").length > 0) {
      // Artist Tab Functionality
      $(".artist-tab").on("click", function (e) {
        e.preventDefault();

        const artistIndex = $(this).data("artist-index");

        // Remove active class from all tabs and content
        $(".artist-tab").removeClass("active");
        $(".artist-content").removeClass("active");

        // Add active class to clicked tab and corresponding content
        $(this).addClass("active");
        $(`.artist-content[data-artist-index="${artistIndex}"]`).addClass("active");

        // Reset all experience items and tags for the new artist
        $(".experience-item").removeClass("active");
        $(".experience-tag").removeClass("active");

        // Activate first experience for the new artist
        const $newActiveArtist = $(`.artist-content[data-artist-index="${artistIndex}"]`);
        $newActiveArtist.find(".experience-tag").first().addClass("active");
        $newActiveArtist.find(".experience-item").first().addClass("active");

        // Reset mobile dropdown to first option
        $newActiveArtist.find(".experience-select").val("0");
      });

      // Experience Tag Functionality
      $(".experience-tag").on("click", function (e) {
        e.preventDefault();

        const experienceIndex = $(this).data("experience-index");
        const $currentArtist = $(this).closest(".artist-content");

        // Remove active class from all tags and items in current artist
        $currentArtist.find(".experience-tag").removeClass("active");
        $currentArtist.find(".experience-item").removeClass("active");

        // Add active class to clicked tag and corresponding experience item
        $(this).addClass("active");
        $currentArtist.find(`.experience-item[data-experience-index="${experienceIndex}"]`).addClass("active");

        // Update mobile dropdown to match
        $currentArtist.find(".experience-select").val(experienceIndex);

        // Update ARIA states
        $currentArtist.find(".experience-tag").attr("aria-pressed", "false");
        $(this).attr("aria-pressed", "true");
      });

      // Mobile Experience Select Functionality
      $(".experience-select").on("change", function (e) {
        const experienceIndex = $(this).val();
        const $currentArtist = $(this).closest(".artist-content");

        // Remove active class from all tags and items in current artist
        $currentArtist.find(".experience-tag").removeClass("active");
        $currentArtist.find(".experience-item").removeClass("active");

        // Add active class to corresponding tag and experience item
        $currentArtist.find(`.experience-tag[data-experience-index="${experienceIndex}"]`).addClass("active");
        $currentArtist.find(`.experience-item[data-experience-index="${experienceIndex}"]`).addClass("active");

        // Update ARIA states
        $currentArtist.find(".experience-tag").attr("aria-pressed", "false");
        $currentArtist.find(`.experience-tag[data-experience-index="${experienceIndex}"]`).attr("aria-pressed", "true");
      });

      // Initialize first experience as active for the active artist
      const $activeArtist = $(".artist-content.active");
      if ($activeArtist.length > 0) {
        $activeArtist.find(".experience-tag").first().addClass("active");
        $activeArtist.find(".experience-item").first().addClass("active");
      }

      // Smooth scroll animations on tab change
      $(".artist-tab").on("click", function () {
        const $content = $(".case-studies-content");
        if (window.innerWidth >= 768) {
          // Only on desktop
          $content.css("opacity", "0.7");
          setTimeout(() => {
            $content.animate({ opacity: 1 }, 300);
          }, 100);
        }
      });

      // Add keyboard accessibility
      $(".artist-tab, .experience-tag").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          $(this).click();
        }
      });

      // Add ARIA attributes for accessibility
      $(".artist-tab").attr("role", "tab").attr("tabindex", "0");
      $(".experience-tag").attr("role", "button").attr("tabindex", "0");
      $(".experience-select").attr("aria-label", "Select experience");

      // Set initial ARIA states
      $(".artist-tab.active").attr("aria-selected", "true");
      $(".artist-tab:not(.active)").attr("aria-selected", "false");
      $(".experience-tag.active").attr("aria-pressed", "true");
      $(".experience-tag:not(.active)").attr("aria-pressed", "false");
    }
    // END – Case Studies Section
  });
})(jQuery);
